const CUSTOM_ADOBE_FONT_SCRIPT_TEMPLATE = (kitId = '') => `(function(d) {
  var config = {
    kitId: '${kitId}',
    scriptTimeout: 3000,
    async: true
  },
  h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\\bwf-loading\\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
})(document);`;

// 400 = normal, 700 = bold
const FONT_WEIGHTS_PRIMARY = [400, 500, 700];
const FONT_WEIGHTS_SECONDARY = [400, 500];

const addAdobeFonts = (kitId = '') => {
  const script = document.createElement('script');
  script.innerHTML = CUSTOM_ADOBE_FONT_SCRIPT_TEMPLATE(kitId);

  document.head.appendChild(script);
};

const CUSTOM_GOOGLE_FONT_SCRIPT_TEMPLATE = (fontsString = '') =>
  `@import url('https://fonts.googleapis.com/css2${fontsString}&display=swap');`;

interface AddGoogleFontsProps {
  fontsRaw: string;
  fontWeights: number[];
}

const addGoogleFonts = ({ fontsRaw = '', fontWeights = [] }: AddGoogleFontsProps) => {
  const SEPARATOR = ',';
  const fonts = fontsRaw.split(SEPARATOR).map((font) => font.trim());
  const fontsString = fonts
    .map((font, index) => {
      const CHARACTER = index === 0 ? '?' : '&';

      return `${CHARACTER}family=${font}:wght@${fontWeights.join(';')}`;
    })
    .join('');
  const newStyle = document.createElement('style');

  newStyle.appendChild(document.createTextNode(CUSTOM_GOOGLE_FONT_SCRIPT_TEMPLATE(fontsString)));
  document.head.appendChild(newStyle);
};

interface AddCustomFontsProps {
  args: string;
  type: 'ADOBE' | 'GOOGLE_PRIMARY' | 'GOOGLE_SECONDARY';
}

export const addCustomFonts = ({ args = '', type = 'ADOBE' }: AddCustomFontsProps) => {
  if (/adobe/i.test(type)) return addAdobeFonts(args);
  if (/google_primary/i.test(type))
    return addGoogleFonts({ fontsRaw: args, fontWeights: FONT_WEIGHTS_PRIMARY });
  if (/google_secondary/i.test(type))
    return addGoogleFonts({ fontsRaw: args, fontWeights: FONT_WEIGHTS_SECONDARY });

  return undefined;
};
